import { useMemo } from 'react';

import { useRubikaUser, useShadUser } from '@/Module/Auth/Hook';

type TGuestVariant = 'شاد' | 'روبیکا';

export const useGuestVariant = (): TGuestVariant => {
  const isRubikaUser = useRubikaUser();
  const isShadUser = useShadUser();
  return useMemo(() => {
    if (isRubikaUser) return 'روبیکا';
    return 'شاد';
  }, [isRubikaUser, isShadUser]);
};
